// src/contexts/GlobalLoading.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import axiosInstance from '../utils/axiosInstance';

// --- Context 作成 ---
const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const GlobalLoading = ({ children }) => {
    const [loadingCount, setLoadingCount] = useState(0);

    const startLoading = () => setLoadingCount(c => c + 1);
    const stopLoading = () => setLoadingCount(c => Math.max(c - 1, 0));

    // --- axios interceptor 連動 ---
    useEffect(() => {
        const reqInterceptor = axiosInstance.interceptors.request.use(config => {
            startLoading();
            return config;
        });

        const resInterceptor = axiosInstance.interceptors.response.use(
            response => {
                stopLoading();
                return response;
            },
            error => {
                stopLoading();
                return Promise.reject(error);
            }
        );

        return () => {
            axiosInstance.interceptors.request.eject(reqInterceptor);
            axiosInstance.interceptors.response.eject(resInterceptor);
        };
    }, []);

    return (
        <LoadingContext.Provider value={{ loading: loadingCount > 0 }}>
            {loadingCount > 0 && (
                <Box
                    position="fixed"
                    top={0} left={0}
                    width="100vw" height="100vh"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="rgba(255,255,255,0.8)"
                    zIndex={9999}
                >
                    <CircularProgress size={120} />
                </Box>
            )}
            {children}
        </LoadingContext.Provider>
    );
};
